/*
 * Section: Best Sellers Slider — Scroll position tracking & control logic
 */

function initBestSellersSlider(section) {
  var track = section.querySelector('.tc-best-sellers-track');
  var progress = section.querySelector('.tc-best-sellers-progress-bar');
  var prevBtn = section.querySelector('.tc-best-sellers-nav-btn.prev');
  var nextBtn = section.querySelector('.tc-best-sellers-nav-btn.next');

  if (!track) return;

  function updateProgressBar() {
    if (!progress) return;
    var scrollWidth = track.scrollWidth;
    var clientWidth = track.clientWidth;
    var maxScroll = scrollWidth - clientWidth;

    if (maxScroll <= 0) {
      progress.style.width = '100%';
      progress.style.left = '0%';
      if (prevBtn) prevBtn.disabled = true;
      if (nextBtn) nextBtn.disabled = true;
      return;
    }

    // Standard visible ratio calculation for custom scroll bar size
    var visibleRatio = clientWidth / scrollWidth;
    var thumbWidth = Math.max(10, Math.min(100, visibleRatio * 100)); // Minimum 10% size
    var scrollPercent = track.scrollLeft / maxScroll;
    var thumbLeft = scrollPercent * (100 - thumbWidth);

    progress.style.width = thumbWidth + '%';
    progress.style.left = thumbLeft + '%';

    // Enable/disable navigation buttons based on scroll boundaries
    if (prevBtn) {
      prevBtn.disabled = maxScroll <= 0;
    }
    if (nextBtn) {
      nextBtn.disabled = maxScroll <= 0;
    }
  }

  // Bind scroll updates
  track.addEventListener('scroll', updateProgressBar);

  // Bind resize events to recalculate bar metrics
  window.addEventListener('resize', updateProgressBar);

  // Execute initial calculation
  updateProgressBar();

  // Re-verify measurements after images load to avoid height/width calculations issues
  var images = track.querySelectorAll('img');
  images.forEach(function(img) {
    if (img.complete) {
      updateProgressBar();
    } else {
      img.addEventListener('load', updateProgressBar);
    }
  });

  // Attach nav arrow controls
  if (prevBtn) {
    prevBtn.addEventListener('click', function() {
      var card = track.querySelector('.tc-best-seller-card');
      if (card) {
        var cardWidth = card.offsetWidth;
        var gap = 24; // Spacing gap between cards
        var scrollWidth = track.scrollWidth;
        var clientWidth = track.clientWidth;
        var maxScroll = scrollWidth - clientWidth;

        if (track.scrollLeft <= 5) {
          track.scrollTo({ left: maxScroll, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: -(cardWidth + gap), behavior: 'smooth' });
        }
      }
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      var card = track.querySelector('.tc-best-seller-card');
      if (card) {
        var cardWidth = card.offsetWidth;
        var gap = 24;
        var scrollWidth = track.scrollWidth;
        var clientWidth = track.clientWidth;
        var maxScroll = scrollWidth - clientWidth;

        if (Math.ceil(track.scrollLeft) >= maxScroll - 5) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: (cardWidth + gap), behavior: 'smooth' });
        }
      }
    });
  }

  // Mouse drag-to-scroll implementation with click hijacking to avoid navigating while dragging
  var isDown = false;
  var startX;
  var scrollLeft;
  var dragMoved = false;

  track.addEventListener('mousedown', function(e) {
    isDown = true;
    dragMoved = false;
    startX = e.pageX - track.offsetLeft;
    scrollLeft = track.scrollLeft;
  });

  track.addEventListener('mouseleave', function() {
    isDown = false;
    track.classList.remove('is-dragging');
  });

  track.addEventListener('mouseup', function() {
    isDown = false;
    track.classList.remove('is-dragging');
  });

  track.addEventListener('mousemove', function(e) {
    if (!isDown) return;
    var x = e.pageX - track.offsetLeft;
    var walk = (x - startX) * 1.5;
    
    // Only count as dragging if they moved more than 5px
    if (Math.abs(x - startX) > 5) {
      dragMoved = true;
      track.classList.add('is-dragging');
    }
    
    if (dragMoved) {
      e.preventDefault();
      track.scrollLeft = scrollLeft - walk;
    }
  });

  // Intercept click events during capture phase and cancel them if we dragged
  track.addEventListener('click', function(e) {
    if (dragMoved) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
}

// Bind load functions
function initAllBestSellers() {
  document.querySelectorAll('.tc-best-sellers-section').forEach(function(section) {
    initBestSellersSlider(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllBestSellers);
} else {
  initAllBestSellers();
}

// Shopify Theme Editor Customizer section re-render hooks
document.addEventListener('shopify:section:load', function(event) {
  if (event.target.classList.contains('tc-best-sellers-section') || event.target.querySelector('.tc-best-sellers-section')) {
    var sectionEl = event.target.classList.contains('tc-best-sellers-section') ? event.target : event.target.querySelector('.tc-best-sellers-section');
    initBestSellersSlider(sectionEl);
  }
});
